import React, {Fragment} from "react";
import {InputWrapper} from "../../parts/input-wrapper/InputWrapper";
import {FieldModel} from "../../shared/model/field-model";
import {FormFooter} from "../../parts/form-footer/FormFooter";

export interface CollectPolicyNoPostCodeFieldSetProps {
    pageName: string;
    dateOfBirthState: FieldModel;
    onDateOfBirthChange:(event: React.ChangeEvent<HTMLInputElement>) => void;
    onDateOfBirthBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
    lastNameState: FieldModel;
    onLastNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onLastNameBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
    policyNoState: FieldModel;
    onPolicyNoChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onPolicyNoBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
    postcodeState: FieldModel;
    onPostcodeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onPostcodeBlur: (event: React.FocusEvent<HTMLInputElement>) => void;

}

export const CollectPolicyAndPostcodeFieldSet = (props: CollectPolicyNoPostCodeFieldSetProps) => {
    const {pageName} = props;
    const {lastNameState, onLastNameChange, onLastNameBlur} = props;
    const {dateOfBirthState, onDateOfBirthChange, onDateOfBirthBlur} = props;
    const {policyNoState, onPolicyNoChange, onPolicyNoBlur} = props;
    const {postcodeState, onPostcodeChange, onPostcodeBlur} = props;
    return (
        <Fragment>
            <InputWrapper
                pageName={pageName}
                name="lastname"
                caption="Last Name"
                fieldState={lastNameState}
                shouldDisplayRequired
                autoCompleteType="family-name"
                onInputChange={onLastNameChange}
                onInputBlur={onLastNameBlur}
                readonly={true}
            />
            <InputWrapper
                pageName={pageName}
                name="dateofbirth"
                caption="Date of Birth"
                fieldState={dateOfBirthState}
                shouldDisplayRequired
                autoCompleteType="family-name"
                onInputChange={onDateOfBirthChange}
                onInputBlur={onDateOfBirthBlur}
                readonly={true}
            />
            <InputWrapper
                pageName={pageName}
                name="policyNo"
                caption="Policy number"
                fieldState={policyNoState}
                shouldDisplayRequired
                autoCompleteType="family-name"
                onInputChange={onPolicyNoChange}
                onInputBlur={onPolicyNoBlur}
            />
            <InputWrapper
                pageName={pageName}
                name="postcode"
                caption="Postcode"
                fieldState={postcodeState}
                shouldDisplayRequired
                autoCompleteType="family-name"
                onInputChange={onPostcodeChange}
                onInputBlur={onPostcodeBlur}
            />
            <FormFooter message="Need to change details?" linkText="Back" redirectTo="/completeregistration"/>
        </Fragment>
    );
};
